<template>
  <div class="pager" v-if="project && project.pages.length>1">
    <div class="counter">
      <div class="num number">{{$route.params.page}}</div><div class="slash">/</div><div class="tot number">{{project.pages.length}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Pager',
    data () {
      return {
      }
    },
    props: {
      project: Object
    }
  };
</script>
<style lang="scss">
  @import "../global.scss";
  .pager {
    .counter {
      .slash {
        display: inline-block;
        width: 1.5rem;
        text-align: center;
      }
      .number {
        &.num {
          text-align: right;
        }
        display: inline-block;
        width: 3rem;
      }
      position:absolute;
      top:1rem;
      @media #{$mini-down} {
        top:5.85rem;
      }
      left:calc(50% - 2.25rem);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pager.vue